import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useHistory } from "react-router-dom";
import "../../css/Coupon.css";
import {
  couponInfo,
  couponUpdatedTime,
  fetchAsyncCoupon,
  createdCoupon,
} from "./CouponSlice";
import CouponInvalid from "./CouponInvalidView";
import CouponValid from "./CouponValidView";
import { create } from "domain";

const Coupon: React.FC = () => {
  const dispatch = useDispatch();
  //データにアクセス
  const couponInfoData = useSelector(couponInfo);
  const couponGetTime = useSelector(couponUpdatedTime);
  //切り替え
  const [valid, setValid] = useState<boolean>(true);
  const [messageFlag, setMessageFlag] = useState(false);

  //初期値ならdispatch
  useEffect(() => {
    if (couponInfoData["invalidCoupon"] === null) {
      dispatch(fetchAsyncCoupon());
    }
  }, [dispatch]);

  //発行されたらフラグ && 情報update
  const createdCouponName = useSelector(createdCoupon);
  useEffect(() => {
    if (createdCouponName) {
      setMessageFlag(true);
      dispatch(fetchAsyncCoupon());
    }
  }, [createdCouponName]);

  //モーダルUI
  const CouponMsg: React.FC = () => {
    return (
      <div className="coupon_message_container">
        <p className="coupon_message">
          coupon_name : {createdCouponName} を発行しました。
          <br />
          挙動を確認してください。
        </p>
      </div>
    );
  };

  return (
    <div className="position_row">
      <div className="coupon_container">
        {messageFlag && <CouponMsg />}
        <h1 className="coupon_title">クーポン</h1>
        <div className="coupon_button_container">
          <button
            className="coupon_change_button"
            onClick={() => setValid(true)}>
            期限内
          </button>
          <button
            className="coupon_change_button"
            onClick={() => setValid(false)}>
            期限切れ
          </button>
        </div>
        <div className="coupon_create_button_container">
          <Link to="/Coupon_create" className="coupon_create_button">
            →クーポン新規作成
          </Link>
        </div>
        <div className="time">最終更新時間 : {couponGetTime}</div>
        <table className="coupon_item_container">
          <thead>
            <tr className="coupon_item_container">
              <th className="coupon_id_item font_item">クーポンID</th>
              <th className="coupon_info_item font_item">情報</th>
              <th className="coupon_type_item font_item">内容</th>
              <th className="coupon_discount_item font_item">発行上限</th>
              <th className="coupon_get_limit_item font_item">発行枚数</th>
              <th className="coupon_get_count_item font_item">開始日</th>
              <th className="coupon_is_reuseable_item font_item">期限</th>
              <th className="coupon_is_single_use_item font_item">再利用</th>
              <th className="coupon_start_date_item font_item">再発行</th>
              <th className="coupon_expiry_item font_item">平日or休日</th>
              {/* <th className="coupon_time_limit_item font_item">時間制約</th> */}
              <th className="coupon_is_weekend_item font_item">開始時間</th>
              <th className="coupon_available_start_time_item font_item">
                終了時間
              </th>
            </tr>
          </thead>
          <tbody>
            {valid ? (
              <CouponValid data={couponInfoData["validCoupon"]!} />
            ) : (
              <CouponInvalid data={couponInfoData["invalidCoupon"]!} />
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Coupon;
